/*
 * サブシステム名：燃費管理
 * 機能名：燃費照会
 */

import DdCustomButton from '@/components/DdCustomButton'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdDropDownMulti from '@/components/DdDropDownMulti'
import DdNenpiSummaryDisp from '@/components/DdNenpiSummaryDisp'
import DdNenpiChartLineBar from '@/components/DdNenpiChartLineBar'
import VTour from '@/components/DdCoachMark.vue'
import CoachMark from './CoachMark/D2FUET0040.js'

import date from '@/ddv2.library/date'
import modals from '@/ddv2.library/modals'
import fraction from '@/ddv2.library/fraction'

import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'

import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdDropDown = () => import('@/components/DdDropDown')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
export default {
  name: 'NenpiList',
  mixins: [flowMixin],
  data: () => ({
    // 一覧制御用
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isExcelDownloader: false,
    activeButtonColor: '#bcced3',
    inActiveButtonColor: '#FFFFFF',
    activeButtonTextColor: 'white--text',
    inActiveButtonTextColor: 'blue--text text--darken-3',
    buttonColor1: '',
    buttonTextColor1: '',
    buttonColor2: '',
    buttonTextColor2: '',
    buttonColor3: '',
    buttonTextColor3: '',
    rows: [],
    categoryBetsuDataList: [],
    sharyoBetsuDataList: [],
    nenkanHensachiDataList: [],
    conditions: {},
    addConditions: {},
    selected: [],
    target: [],

    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS,

    modeKengen: 0,
    pageCount: 0,
    headerMode: 1
  }),
  components: {
    VTour,
    DdCodeTextBox,
    DdCustomButton,
    DdDataTable,
    DdDateRangeBox,
    DdDefaultButton,
    DdDropDown,
    DdNarrowDownTextBox,
    DdNenpiSummaryDisp,
    DdRadioButton,
    DdRowCountBox,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox,
    DdTransparentButton,
    DdDropDownMulti,
    DdNenpiChartLineBar,
    DdIconButtonWithTooltip
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      nenpiCategoryList: 'DDMasters/mstNenpiCategory',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      helpUseFlg: 'users/helpUseFlg'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        if (elem.count) {
          elem.konkaiNenpi = elem.konkaiNenpi / elem.count
          elem.zengetsuNenpi = elem.zengetsuNenpi / elem.count
          elem.zennenNenpi = elem.zennenNenpi / elem.count
        }
        elem.konkaiNenpiDisp = elem.konkaiNenpi ? filter.numericFormatter(elem.konkaiNenpi) : ''
        elem.kyuyuKingakuHensachiDisp = elem.kyuyuKingakuHensachi ? filter.numericFormatter(Math.abs([elem.kyuyuKingakuHensachi])) : ''
        elem.sokoKyoriDisp = elem.sokoKyori ? filter.numericFormatter(elem.sokoKyori) : ''
        elem.kyuyuRyoDisp = elem.kyuyuRyo ? filter.numericFormatter(elem.kyuyuRyo) : ''
        elem.zengetsuNenpiDisp = elem.zengetsuNenpi ? filter.numericFormatter(elem.zengetsuNenpi) : ''
        elem.zengetsuNenpiHensachi = elem.zengetsuNenpi && elem.konkaiNenpi ? Math.trunc(fraction.calcSubtract(elem.konkaiNenpi, elem.zengetsuNenpi) * 10) / 10 : ''
        elem.zengetsuNenpiHensachiDisp = elem.zengetsuNenpi && elem.konkaiNenpi ? filter.numericFormatter(Math.abs([elem.zengetsuNenpiHensachi])) : ''
        elem.zennenNenpiDisp = elem.zennenNenpi ? filter.numericFormatter(elem.zennenNenpi) : ''
        elem.zennenNenpiHensachi = elem.zennenNenpi && elem.konkaiNenpi ? Math.trunc(fraction.calcSubtract(elem.konkaiNenpi, elem.zennenNenpi) * 10) / 10 : ''
        elem.zennenNenpiHensachiDisp = elem.zennenNenpi && elem.konkaiNenpi ? filter.numericFormatter(Math.abs([elem.zennenNenpiHensachi])) : ''
        return elem
      }).sort((a, b) => {
        if (a.mstSharyoNm > b.mstSharyoNm) { return 1 }
        if (a.mstSharyoNm === b.mstSharyoNm) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.eigyoshoCd > b.eigyoshoCd) { return 1 }
        if (a.eigyoshoCd === b.eigyoshoCd) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.hyojiOrder > b.hyojiOrder) { return 1 }
        if (a.hyojiOrder === b.hyojiOrder) { return 0 }
        return -1
      })
    },
    dispHeader () {
      const self = this
      let header = []
      if (self.headerMode === 1) {
        header = [
          { text: 'ID', value: 'nenpiCategoryId', align: ' d-none' },
          { text: 'カテゴリ', value: 'nenpiCategoryNm', width: '150px' },
          { text: '実燃費', value: 'konkaiNenpiDisp', align: 'end', width: '40px' },
          { text: '指標比較', value: 'kyuyuKingakuHensachiDisp', align: 'end', width: '40px' },
          { text: '走行距離', value: 'sokoKyoriDisp', align: 'end', width: '40px' },
          { text: '給油（ℓ）', value: 'kyuyuRyoDisp', align: 'end', width: '40px' },
          { text: '前回燃費', value: 'zengetsuNenpiDisp', align: 'end', width: '40px' },
          { text: '前年燃費', value: 'zennenNenpiDisp', align: 'end', width: '40px' },
          { text: '', value: '', width: '150px' }
        ]
      } else if (self.headerMode === 2) {
        header = [
          { text: 'ID', value: 'mstSharyoId', align: ' d-none' },
          { text: '車両', value: 'mstSharyoNm', width: '150px' },
          { text: '営業所', value: 'eigyoshoNm', width: '150px' },
          { text: 'カテゴリ', value: 'nenpiCategoryNm', width: '150px' },
          { text: '実燃費', value: 'konkaiNenpiDisp', align: 'end', width: '40px' },
          { text: '指標比較', value: 'kyuyuKingakuHensachiDisp', align: 'end', width: '40px' },
          { text: '走行距離', value: 'sokoKyoriDisp', align: 'end', width: '40px' },
          { text: '給油（ℓ）', value: 'kyuyuRyoDisp', align: 'end', width: '40px' },
          { text: '前回燃費', value: 'zengetsuNenpiDisp', align: 'end', width: '40px' },
          { text: '前年燃費', value: 'zennenNenpiDisp', align: 'end', width: '40px' },
          { text: '主たる乗務員', value: 'jomuinNm' },
          { text: '初回登録年月', value: 'shonendoYm' },
          { text: '車両分類１', value: 'sharyoGroupSbt1Nm' },
          { text: '車両分類２', value: 'sharyoGroupSbt2Nm' }
        ]
      }
      return header
    },
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      const resultArray = this.eigyoshoList.filter(function (elem) {
        return elem.tekiyoStartYmd <= target && elem.tekiyoEndYmd >= target && elem.eigyoshoKbn !== '03'
      }).map(elem => {
        return {
          value: elem.id,
          text: `${elem.eigyoshoCd}:${elem.eigyoshoNm}`
        }
      })
      return resultArray
    },
    // 燃費カテゴリフィルター
    filteredNenpiCategoryList () {
      var defArray = [{ value: 0, text: 'カテゴリ未設定' }]
      const resultArray = this.nenpiCategoryList.filter(function (elem) {
        return elem.hyojiFlg === true
      }).map(elem => {
        return {
          value: elem.id,
          text: `${elem.nenpiCategoryCd}:${elem.nenpiCategoryNm}`
        }
      })
      return defArray.concat(resultArray)
    },
    // Excelボタン活性条件
    isExcelButtonDisabled () {
      return this.rows.length === 0
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'mstnenpicategory'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmHaishaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('PrmHaishaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmHaishaList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmHaishaList.restoreViewPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.rows = c.cache.value.rows || []
            }
            resolve()
          })
        },
        settingViewScroll: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmHaishaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
              self.onReloadButtonClick()
              self.onDispModeButtonClick(1)
            })

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
    },
    onReloadButtonClick: function (e) {
      this.onNenpiCategoryBetsuSearchButtonClick()
      this.onNenpiSharyoBetsuSearchButtonClick()
      this.onNenkanHensachiSearchButtonClick()
      this.$refs.nenpiSummaryDisp.searchNenpiSummary(this.conditions.searchTargetStartYmdString, this.conditions.searchTargetEndYmdString)
    },
    onNenpiCategoryBetsuSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/D2FUED0040/NenpiCategoryBetsuSearch', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.categoryBetsuDataList = data.payload
          if (self.headerMode === 1) {
            self.categoryBetsuListFilter()
          }
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    // 選択されている営業所に一致するデータを、カテゴリ別に集計する。
    categoryBetsuListFilter: function (e) {
      const self = this
      let targetList = Object.assign([], self.categoryBetsuDataList)
      if (self.addConditions.eigyoshoIdList.length > 0) {
        targetList = targetList.filter(function (elem) {
          return self.addConditions.eigyoshoIdList.includes(elem.eigyoshoId)
        })
      }
      if (self.addConditions.nenpiCategoryIdList.length > 0) {
        targetList = targetList.filter(function (elem) {
          return self.addConditions.nenpiCategoryIdList.includes(elem.nenpiCategoryId)
        })
      }
      const resultList = targetList.reduce((result, current) => {
        const element = result.find((p) => p.nenpiCategoryId === current.nenpiCategoryId)
        if (element) {
          element.count++
          element.konkaiNenpi += current.konkaiNenpi
          element.kyuyuKingakuHensachi += current.kyuyuKingakuHensachi
          element.kyuyuRyo += current.kyuyuRyo
          element.sokoKyori += current.sokoKyori
          element.zengetsuNenpi += current.zengetsuNenpi
          element.zennenNenpi += current.zennenNenpi
        } else {
          result.push({
            nenpiCategoryId: current.nenpiCategoryId,
            nenpiCategoryCd: current.nenpiCategoryCd,
            nenpiCategoryNm: current.nenpiCategoryNm,
            hyojiOrder: current.hyojiOrder,
            count: 1,
            konkaiNenpi: current.konkaiNenpi,
            kyuyuKingakuHensachi: current.kyuyuKingakuHensachi,
            kyuyuRyo: current.kyuyuRyo,
            sokoKyori: current.sokoKyori,
            zengetsuNenpi: current.zengetsuNenpi,
            zennenNenpi: current.zennenNenpi
          })
        }
        return result
      }, [])
      console.log(resultList)
      this.rows = Object.assign([], resultList)
    },
    onNenpiSharyoBetsuSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/D2FUED0040/NenpiSharyoBetsuSearch', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.sharyoBetsuDataList = data.payload
          if (self.headerMode === 2) {
            self.sharyoBetsuListFilter()
          }
        },
        getSavedInputMethod: function () {
          return {}
        },
        isNoMessageModeMethod: function () {
          return true
        }
      }
      this.search(opt)
    },
    // 選択されている営業所および燃費カテゴリに一致するデータに絞り込む
    sharyoBetsuListFilter: function (e) {
      const self = this
      let targetList = Object.assign([], self.sharyoBetsuDataList)
      if (self.addConditions.eigyoshoIdList.length > 0) {
        targetList = targetList.filter(function (elem) {
          return self.addConditions.eigyoshoIdList.includes(elem.eigyoshoId)
        })
      }
      if (self.addConditions.nenpiCategoryIdList.length > 0) {
        targetList = targetList.filter(function (elem) {
          return self.addConditions.nenpiCategoryIdList.includes(elem.nenpiCategoryId)
        })
      }
      this.rows = Object.assign([], targetList)
    },
    onNenkanHensachiSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/D2FUED0040/KyuyuJissekiNenkanHensachiSearch', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.nenkanHensachiDataList = data.payload
          if (self.headerMode === 3) {
            self.$refs.nenpiChartLineBar.setDataListFromMainVue(self.conditions.searchTargetEndYmdString, self.addConditions.eigyoshoIdList, self.addConditions.nenpiCategoryIdList, self.nenkanHensachiDataList)
          }
        },
        getSavedInputMethod: function () {
          return {}
        },
        isNoMessageModeMethod: function () {
          return true
        }
      }
      this.search(opt)
    },
    onInputAddConditions: function (e) {
      this.$refs.nenpiSummaryDisp.calcDispKingaku(this.addConditions.eigyoshoIdList, this.addConditions.nenpiCategoryIdList)
      if (this.headerMode === 1) {
        this.categoryBetsuListFilter()
      } else if (this.headerMode === 2) {
        this.sharyoBetsuListFilter()
      } else if (this.headerMode === 3) {
        this.$refs.nenpiChartLineBar.calcDispKingaku(this.conditions.searchTargetEndYmdString, this.addConditions.eigyoshoIdList, this.addConditions.nenpiCategoryIdList)
      }
    },
    inputSerchTargetYmd: function (from, to) {
      this.onReloadButtonClick()
    },
    onDispModeButtonClick: function (p) {
      const self = this
      if (p === 1) {
        self.headerMode = 1
        self.categoryBetsuListFilter()
        self.buttonColor1 = self.activeButtonColor
        self.buttonTextColor1 = self.activeButtonTextColor
        self.buttonColor2 = self.inActiveButtonColor
        self.buttonTextColor2 = self.inActiveButtonTextColor
        self.buttonColor3 = self.inActiveButtonColor
        self.buttonTextColor3 = self.inActiveButtonTextColor
      } else if (p === 2) {
        self.headerMode = 2
        self.sharyoBetsuListFilter()
        self.buttonColor1 = self.inActiveButtonColor
        self.buttonTextColor1 = self.inActiveButtonTextColor
        self.buttonColor2 = self.activeButtonColor
        self.buttonTextColor2 = self.activeButtonTextColor
        self.buttonColor3 = self.inActiveButtonColor
        self.buttonTextColor3 = self.inActiveButtonTextColor
      } else if (p === 3) {
        self.headerMode = 3
        self.buttonColor1 = self.inActiveButtonColor
        self.buttonTextColor1 = self.inActiveButtonTextColor
        self.buttonColor2 = self.inActiveButtonColor
        self.buttonTextColor2 = self.inActiveButtonTextColor
        self.buttonColor3 = self.activeButtonColor
        self.buttonTextColor3 = self.activeButtonTextColor
        self.$nextTick(() => {
          self.$refs.nenpiChartLineBar.setDataListFromMainVue(self.conditions.searchTargetEndYmdString, self.addConditions.eigyoshoIdList, self.addConditions.nenpiCategoryIdList, self.nenkanHensachiDataList)
        })
      }
    },
    onNenpiCategoryRowClick: function (param) {
      const nenpiCategoryIdList = []
      nenpiCategoryIdList.push(param)
      this.addConditions.nenpiCategoryIdList = Object.assign([], nenpiCategoryIdList)
      this.onDispModeButtonClick(2)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const self = this
      const d = new Date()
      const initConditions = {
        searchTargetStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        searchTargetEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1)
      }
      const initAddConditions = {
        eigyoshoIdList: [],
        nenpiCategoryIdList: []
      }
      self.conditions = initConditions
      self.addConditions = initAddConditions
      self.headerMode = 1
      self.searchText = ''
      self.rows = []
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.initBindVariables()
            this.onReloadButtonClick()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onExcelButtonClick: function (e) {
      this.isExcelDownloader = true
      const rec = {
        searchTargetStartYmdString: this.conditions.searchTargetStartYmdString,
        searchTargetEndYmdString: this.conditions.searchTargetEndYmdString,
        eigyoshoIdList: this.addConditions.eigyoshoIdList,
        nenpiCategoryIdList: this.addConditions.nenpiCategoryIdList,
        searchMode: this.headerMode
      }
      this.HttpClient
        .requestFileByPost('/api/v1/D2FUED0040/excelOutput', rec).then(data => {
          // aタグにファイル仕込んでClickする処理
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('exceldownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = this.headerMode === 1 ? '燃費管理(カテゴリ別)_' + ts + '.xlsx' : '燃費管理(車両別)_' + ts + '.xlsx'
          elem.click()
          this.isExcelDownloader = false
        })
    },
    // 検索前チェック
    searchValidate: function () {
      // 発生年月日不整合チェック
      if (this.conditions.searchTargetStartYmdString && this.conditions.searchTargetEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.searchTargetStartYmdString, this.conditions.searchTargetEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.searchTargetStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          modals.showToastMessage('COME0014', null, 500, null, 'error')
          return false
        }
      } else {
        modals.showToastMessage('COME0008', null, 500, null, 'error')
        return false
      }
      return true
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      // this.$set(this, 'itemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    onDummyFunction: function () {
      return null
    }
  }
}
